import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import STATES from '~/app/common/structures/states';
import {
  Message,
  Input,
  Select,
  Option,
  Button
} from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { showIntercom } from 'barnyard/utils';
import { VENDOR_MERCHANT_UPDATE_FORM } from '../constants';
import { isValidString } from '~/accounts/signup/forms/utils';

const classNamePrefix = 'Signup--Form';
const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;


const validate = (values) => {
  const errors = {};

  if (!urlRegex.test(values.website)) {
    errors.website = 'Please enter a valid website URL';
  }

  if (!isValidString(values.contact_name)) {
    errors.contact_name = 'Please enter a primary contact name';
  }

  if (!isValidString(values.contact_email)) {
    errors.contact_email = 'Please enter a primary email adddress';
  }

  if (!isValidString(values.phone_number)) {
    errors.phone_number = 'Please enter a primary phone number';
  }

  if (!isValidString(values.postalcode)) {
    errors.postalcode = 'Please enter your zipcode';
  }

  if (!isValidString(values.city)) {
    errors.city = 'Please enter your city information';
  }

  if (!isValidString(values.state)) {
    errors.state = 'Please enter your state information';
  }

  return errors;
};

class VendorInformationForm extends Component {
  constructor(props) {
    super(props);
    _.bindAll(this, 'onWebsiteBlur');
  }

  onWebsiteBlur(e) {
    const { change } = this.props;
    const { target: { value } } = e;
    if (value && !_.startsWith(value, 'http')) {
      change('website', `https://${value}`);
      // prevent the normal change event
      e.preventDefault();
    }
  }

  render() {
    const {
      handleSubmit,
      error,
      onZipcodeChange,
      submitting
    } = this.props;

    return (
      <form className={classNamePrefix} onSubmit={handleSubmit}>
        {
          error && (
            <Message
              color='danger'
              border={true}
              message={(
                <>
                  <strong><h4>{error.title}</h4></strong>
                  <p>{error.details}</p>
                </>
              )}
            />
          )
        }
        <Row gutter='md' className={`${classNamePrefix}__row`}>
          <Col xs={12} md={6}>
            <Field
              name='contact_name'
              label='Primary Contact Name*'
              placeholder='Contact Name'
              component={Input}
              autoComplete='off'
            />
          </Col>
          <Col xs={12} md={6}>
            <Field
              name='contact_position'
              label='Contact Position'
              placeholder='Owner, Manager, etc'
              component={Input}
              autoComplete='off'
            />
          </Col>
        </Row>
        <Row gutter='md' className={`${classNamePrefix}__borderRow`}>
          <Col xs={12} md={6}>
            <Field
              name='contact_email'
              label='Primary Contact Email*'
              placeholder='Contact Email'
              component={Input}
              autoComplete='off'
              preIcon={['fal', 'envelope']}
            />
          </Col>
          <Col xs={12} md={6}>
            <Field
              name='website'
              label='Website*'
              placeholder='https://www.purrrfect-business.com'
              component={Input}
              autoComplete='off'
              preIcon={['fal', 'link']}
              type='url'
              onBlur={this.onWebsiteBlur}
            />
          </Col>
        </Row>
        <Row gutter='md' className={`${classNamePrefix}__row`}>
          <Col xs={12} md={8}>
            <Field
              name='address_one'
              label='Business Street Address*'
              placeholder='Street Address'
              component={Input}
              autoComplete='off'
            />
          </Col>
          <Col xs={12} md={4}>
            <Field
              name='address_two'
              label='Suite'
              placeholder='Suite, Building, etc.'
              component={Input}
              autoComplete='off'
            />
          </Col>
        </Row>
        <Row gutter='md' className={`${classNamePrefix}__row ${classNamePrefix}__row`}>
          <Col xs={12} md={2}>
            <Field
              name='postalcode'
              label='Zipcode*'
              placeholder='Zipcode'
              component={Input}
              onChange={onZipcodeChange}
              autoComplete='off'
            />
          </Col>
          <Col xs={12} md={4}>
            <Field
              name='city'
              label='City*'
              placeholder='City'
              component={Input}
              autoComplete='off'
            />
          </Col>
          <Col xs={12} md={2}>
            <Field
              name='state'
              label='State*'
              placeholder='State'
              format={null}
              showSearch={true}
              component={Select}
              autoComplete='off'
              optionFilterProp='name'
            >
              {
                _.map(
                  STATES,
                  (stateName, stateKey) => (
                    <Option key={stateKey} value={stateKey} name={`${stateName},${stateKey}`}>{stateKey}</Option>
                  )
                )
              }
            </Field>
          </Col>
          <Col xs={12} md={4}>
            <Field
              name='phone_number'
              label='Business Phone Number*'
              preIcon={['fal', 'phone']}
              placeholder='(212) 867-5309'
              displayFormat='phone'
              component={Input}
              autoComplete='off'
            />
          </Col>
        </Row>
        <Row className={`${classNamePrefix}__buttons`} gutter='md' justify='edges'>
          <Col>
            <Button
              color='primary'
              naked={true}
              onClick={showIntercom}
              type='button'
              className='u-padding0'
            >
              Need Help? Let&apos;s Chat!
            </Button>
          </Col>
          <Col xs={12} md={6}>
            <Button
              className='button'
              color='primary'
              type="submit"
              full={true}
              loading={submitting}
            >
              Enter Selling Portal
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}


VendorInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onZipcodeChange: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
  error: PropTypes.object,
  submitText: PropTypes.string,
  submitting: PropTypes.bool,
  change: PropTypes.func.isRequired
};

export default reduxForm({
  form: VENDOR_MERCHANT_UPDATE_FORM,
  validate
})(VendorInformationForm);
